module.exports = __webpack_public_path__ + "static/media/AccountInquiry.5599c760.svg";